import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingDate = simpleSet as
  redux.reducers.calculationMode.settings.information.shippingDate;

export const shippingDate = setCalculationModeShippingDate(
  'SET_CALCULATION_MODE_SHIPPING_DATE',
  new Date().toISOString().split('T')[0]
);
